exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".training-projects-list thead tr th {\n  user-select: none;\n}\n", ""]);

// exports
